import CommonApp from '../../app.js';
import addressFormTemplate from './address-form.html';
import {configManager} from '../../../util/config-manager/config-manager.js';
import {AutoCompleteAddress} from '../../../models/autocompleteAddress.js';
import {addressController} from './address-controller.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';

var addressDirective = function() {
    return {
        restrict: 'E',
        scope: {
            addressView: '=',
            countryCode: '=',
            addressConfigs: '=',
            addressFormatter: '=',
            language: '=',
            translations: '=',
            address: '=',
            isSubmitted: '=',
        },
        controller: addressController,
        controllerAs: 'ctrl',
        bindToController: true,
        template: addressFormTemplate
    };
};

CommonApp.module.service('AutoCompleteAddress', function() {
    return AutoCompleteAddress;
});

CommonApp.module.service('configManager', function() {
    return configManager;
});

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});

addressController.$inject = ['$scope', '$window', 'AutoCompleteAddress', 'configManager', 'AccountConfigManager'];

CommonApp.module.controller('addressController', addressController);

CommonApp.module.directive('nsAddressForm', addressDirective);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/address/address-adapter.js
// module id = 262
// module chunks = 0